<h1 mat-dialog-title class="text sign-out-h1">{{ 'Modal_Sign_Out' | translate }}</h1>
<div mat-dialog-actions class="text sign-out-button-container">
  <button mat-raised-button (click)="signOutNoClick()">{{ 'No' | translate }}</button>
  <button mat-raised-button (click)="signOutYesClick()">
    <span class="spinner" *ngIf="isLoading"></span>
    <span *ngIf="!isLoading">{{ 'Yes' | translate }}</span>
    <span class="transparentColor" *ngIf="isLoading">-</span>
  </button>
</div>
